__turbopack_context__.v({
  "listWrapper": "AddressLookup-module-scss-module__sF65tG__listWrapper",
  "root": "AddressLookup-module-scss-module__sF65tG__root",
});
